import { Injectable } from '@angular/core';
import {AResourceService} from "./a-resource.service";
import {AddressModel} from "../../models/resources/address.model";

@Injectable({
  providedIn: 'root',
})
export class AddressService extends AResourceService<AddressModel> {
  constructor() {
    super('/addresses', true);
  }

  setCustomerId(id: number) {
    this.setResourceUrl(`/customers/${id}/addresses`);
  }
}
